import React, { Component } from 'react';
import { Period } from './Period';
import '../styles/style.css';
import '../styles/Spinner.css';

export class PeriodContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            periodArr: [],
            test: 'test',
            periodState: 0,
            spinner: 'spinner-hide'
        };
    }

    componentDidUpdate() {
        if (this.props.periodyear !== this.state.periodState) {
            console.log('fetching period' + this.props.periodyear);
            this.setState({
                periodArr: []
            });
            this.getComponentData();
            this.setState({
                periodState: this.props.periodyear
            });
        }
    }

    componentDidMount() {
        this.getComponentData();
        this.setState({
            periodState: this.props.periodyear
        });
    }

    getComponentData() {
        let baseUrl = window.location.origin;

        this.setState({
            spinner: 'spinner-show'
        });

        let unionUrlParam = '';

        if (window.location.search === '?union=bor') {
            unionUrlParam = '/bor';
        }

        fetch(baseUrl + '/api/period/' + this.props.periodyear + unionUrlParam).then(res => res.json()).then(
            (result) => {
                let newPeriodsArr = [];

                for (let i = 0; i < result.periods.length; i++) {
                    newPeriodsArr.push(<Period key={i} year={result.periods[i].year} month={result.periods[i].month} test={this.state.test} unions={result.periods[i].unions} areas={result.periods[i].areas} />);
                }

                this.setState({
                    periodArr: newPeriodsArr,
                    spinner: 'spinner-hide'
                });
                //let mfdNew = { name: result.name, branches: result.branches };
                //this.setState({
                //    mfd: mfdNew
                //}, () => { console.log(this.state.mfd); });
            }
        );
    }

    render() {
        return (
            <div>
                <p className='select-year-headline'>V&aelig;lg m&aring;ned</p>
                <div className={this.state.spinner}>
                    <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
                <div>{this.state.periodArr}</div>
            </div>
        );
    }

}